import { RaceProgressLapMarkRaw } from "./interfaces/race_progress_lap_mark_raw.interface";
import { RaceProgressLapRaw } from "./interfaces/race_progress_lap_raw.interface";
import { RaceProgressLapPenalty } from "./race_progress_lap_penalty";

export class RaceProgressLap {
    DSQ: number;
    deltaLeader: number;
    marks: RaceProgressLapMarkRaw[];
    penalty: RaceProgressLapPenalty[];
    penaltyTime: number;
    time: number;
    timeFromStart: number;
    constructor(obj: RaceProgressLapRaw) {
        this.DSQ = obj.DSQ;
        this.deltaLeader = obj.deltaLeader;
        // TODO сделать скорее всего класс и преобразовать все свойства времени.
        this.marks = obj.marks;
        this.penalty = obj.penalty.map((item) => new RaceProgressLapPenalty(item));
        this.penaltyTime = obj.penaltyTime;
        this.time = obj.time;
        this.timeFromStart = obj.timeFromStart;
    }
}